import React from 'react';
import { SectionStyled, SubtitleStyled, TitleStyled } from './styles';

interface Props {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  className?: string;
}

export const ContentSection: React.FC<Props> = ({ title, subtitle, children, className }) => {
  return (
    <SectionStyled className={className}>
      <TitleStyled>{title}</TitleStyled>
      <SubtitleStyled>{subtitle}</SubtitleStyled>
      {children}
    </SectionStyled>
  );
};
